import React from 'react';
import {Radio} from 'antd';
import commonRefHOC from '../../commonRefHOC';

export default commonRefHOC(Radio);